import { useState } from "react";
import {
  Button,
  Grid,
  CircularProgress,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { createBlobInContainerWithName } from "src/utils/filesApi";
import Iconify from "../iconify/Iconify";

const defaultQuestion = {
  type: "team",
  text: "",
  targetFirstName: "",
  targetLastName: "",
  level: "EASY",
  logoId: 0,
  teamLogoId: 0,
  primaryImage: "",
  secondaryImage: "",
  statsName: "",
};
const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

export default function QuestionDialog(props) {
  const [loading, setLoading] = useState(false);
  const [showAssetsType, setShowAssetsType] = useState(null);
  const [question, setQuestion] = useState(defaultQuestion);
  const [teamPlayers, setTeamPlayers] = useState([]);
  const [imageLibraryFiles, setImageLibraryFiles] = useState([]);
  const onCancel = () => {
    setShowAssetsType(null);
    props.onClose();
  };
  const handleChangeType = (event) => {
    setQuestion((prevState) => ({
      ...prevState,
      type: event.target.value,
    }));
  };
  const handleChangeLevel = (event) => {
    setQuestion((prevState) => ({
      ...prevState,
      level: event.target.value,
    }));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;

    setQuestion((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const uploadFiles = (event, name, folder) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      let uploadPromises = [];
      const randomId = getRandomInt(10000);

      uploadPromises.push(
        createBlobInContainerWithName(files[0], `${folder}/${randomId}.png`)
      );

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          const url = await Promise.all(uploadPromises);

          if (name === "logoId") {
            setQuestion((prevState) => ({
              ...prevState,
              logoId: randomId,
              primaryImage: url[0],
            }));
          } else {
            setQuestion((prevState) => ({
              ...prevState,
              teamLogoId: randomId,
              secondaryImage: url[0],
            }));
          }
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  const createQuestionHandler = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${props.gameId}/custom-question`,
        question
      )
      .then((response) => {
        window.location.reload(true);
      });
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Create Question</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={5} sx={{ m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel id="status-select-label">Type</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status-select"
                    value={question.type ?? "team"}
                    label="Type"
                    onChange={handleChangeType}
                  >
                    <MenuItem value="team">Team</MenuItem>
                    <MenuItem value="player">Player</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={5} sx={{ m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel id="status-select-label">Level</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status-select"
                    value={question.level ?? "EASY"}
                    label="Type"
                    onChange={handleChangeLevel}
                  >
                    <MenuItem value="EASY">EASY</MenuItem>
                    <MenuItem value="MED">MED</MenuItem>
                    <MenuItem value="HARD">HARD</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="targetFirstName"
                  label="First Name"
                  type="email"
                  fullWidth
                  value={question.targetFirstName}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="targetLastName"
                  label="Last Name"
                  type="email"
                  fullWidth
                  value={question.targetLastName}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="text"
                  label="Question Text (+0.5 PPG)"
                  type="email"
                  fullWidth
                  value={question.text}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="statsName"
                  label="Stats Name (assists)"
                  type="email"
                  fullWidth
                  value={question.statsName}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              {question.type === "team" && (
                <Grid item xs={6}>
                  <FormLabel id="card-format-label">Primary Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) =>
                        uploadFiles(event, "logoId", "teams")
                      }
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {question.primaryImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={question.primaryImage}
                    />
                  ) : null}
                </Grid>
              )}
              {question.type === "player" && (
                <>
                  <Grid item xs={6}>
                    <FormLabel id="card-format-label">Primary Image</FormLabel>
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                    >
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(event) =>
                          uploadFiles(event, "logoId", "players")
                        }
                      />
                      <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                    </IconButton>
                    {question.primaryImage ? (
                      <img
                        style={{
                          margin: "0 auto",
                          width: 100,
                          background: "grey",
                        }}
                        alt="Image"
                        src={question.primaryImage}
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={6}>
                    <FormLabel id="card-format-label">
                      Secondary Image
                    </FormLabel>
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                    >
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(event) =>
                          uploadFiles(event, "teamLogoId", "teams")
                        }
                      />
                      <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                    </IconButton>
                    {question.secondaryImage ? (
                      <img
                        style={{
                          margin: "0 auto",
                          width: 100,
                          background: "grey",
                        }}
                        alt="Image"
                        src={question.secondaryImage}
                      />
                    ) : null}
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button
            onClick={() => createQuestionHandler()}
            autoFocus
            disabled={
              !question.targetFirstName ||
              !question.text ||
              !question.primaryImage ||
              !question.statsName
            }
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
